import {Injectable} from '@angular/core';
import {EaseType} from '../../../enums/ease.enum';

@Injectable({
    providedIn: 'root'
})
export class EasingService {
    calculateProgressByType(type: EaseType, progress) {
        switch (type) {
            case EaseType.EASE_IN:
                return this.easeInCirc(progress);
            case EaseType.EASE_OUT:
                return this.easeOutCirc(progress);
            case EaseType.EASE_IN_BOUNCE:
                return this.easeInBounce(progress);
            case EaseType.EASE_OUT_BOUNCE:
                return this.easeOutBounce(progress);
            case EaseType.LINEAR:
                return progress;
            default:
                return progress;
        }
    }

    private easeInCirc(progress) {
        return -1 * (Math.sqrt(1 - progress * progress) - 1);
    }

    private easeOutCirc(progress) {
        return Math.sqrt(1 - (progress - 1) * (progress - 1));
    }

    private easeInBounce(progress) {
        const amplitude = 0.08;

        if (progress < 0.25) {
            return progress * 4;
        }

        return (amplitude / progress) * (-Math.sin(4 * Math.PI * progress)) / Math.exp(4.5 * progress) + 1;
    }

    private easeOutBounce(progress) {
        const amplitude = 0.003;

        if (progress < 0.75) {
            return (amplitude * Math.sin(4 * Math.PI * progress) / Math.exp(-5 * progress)) * -1;
        }

        return (4 * progress) - 3;
    }
}
